var map = {
	"./amwnsr/i-bg.gif": "527c",
	"./amxpj/i-bg.gif": "c7fd",
	"./bqty/i-bg.gif": "32de",
	"./funw/i-bg.gif": "20fe",
	"./wbgj/i-bg.gif": "c35c",
	"./xiaocao/i-bg.gif": "181c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6585";